import JoinTripCard from "./JoinTripCard";
import dayjs from "dayjs";
import { Icons } from "../data/Icons";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { calculateAge } from "../Pages/Profile";

const MultipleJoinTripCard = ({ trip, onClick }) => {

    return (
        <JoinTripCard
            className="trip-card"
            title={trip.title}
            subtitle={""}
            participants={trip.participants}
            image={trip.image}
            description={<TripDescription trip={trip} />}
            onClick={() => onClick(trip)}
        />
    );
};

const TripDescription = ({ trip }) => {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchUsers = async () => {
            const newUsers = [];
            for (let i = 0; i < trip.participants.length; i++) {
                try {
                    const userRef = await getDoc(doc(db, 'users', trip.participants[i]));
                    if (userRef.exists()) {
                        newUsers.push(userRef.data());
                    }
                } catch (error) {
                    console.error(`Error fetching user ${trip.participants[i]}:`, error);
                }
            }
            setUsers(newUsers);
        };

        if (trip.participants?.length) {
            fetchUsers();
        }
    }, [trip.participants]);



    const [description, setDescription] = useState("");
    const [favorites, setFavorites] = useState("");
    useEffect(() => {
        if (users.length == 0)
            return;
        let desc = "";
        const length = users.length > 2 ? 2 : users.length;
        for (let i = 0; i < length; i++) {
            const age = calculateAge(dayjs(users[i].birthDate))
            desc += `${users[i].title} ${age}`;
            if (i !== length - 1) {
                desc += ", ";
            }
        }

        const rest = users.length - length;
        if (rest > 0) {
            desc += ` ועוד ${rest} אחרים`;
        }

        const allInterest = [];
        users.forEach((participant) => {
            allInterest.push(participant.favorite_trip_styles);
        });
        const favorites = getCommonFavorites(allInterest);

        setFavorites(favorites);
        setDescription(desc);
    }, [users])

    const dateTime = trip.timestamp
        ? dayjs(trip.timestamp.toDate()).format("DD/MM/YYYY, בשעה HH:mm")
        : "תאריך לא זמין";

    return (
        <>
            <div className="card-description-main-text">{description}</div>
            {trip.timestamp && (
                <div className="card-description-detail">
                    {Icons.date}{dateTime}
                </div>
            )}
            {favorites !== "" &&
                <div className="card-description-detail favorites-line">
                    סגנונות הטיול המשותפים לקבוצה: <span className="favorites-list">{favorites}</span>
                </div>
            }
        </>
    );
}

function getCommonFavorites(favorites) {
    if (!Array.isArray(favorites) || favorites.length === 0) return "";
    const sets = favorites
        .filter((row) => Array.isArray(row))
        .map((row) => new Set(row.map((item) => item.trim())));
    if (sets.length === 0) return "";
    let common = sets[0];
    for (let i = 1; i < sets.length; i++) {
        common = new Set([...common].filter((x) => sets[i].has(x)));
    }
    return [...common].join(", ");
}

export default MultipleJoinTripCard;

